import React from 'react';
import { getPlattsformFields, submitToMarketo } from '../utilities/form-utilities';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

const getPlattsSubmissionBody = (
    productName: string,
    data: RequestATrialState,
) => {
    const body: RATPlattsRequest = {
        city: data.City,
        company: data.Company,
        marketoIndustry: data.CompanyType as string,
        country: data.CompanyCountry as string,
        nationality: data.Country as string,
        email: data.Email,
        firstName: data.FirstName,
        title: data.JobFunction as string,
        lastName: data.LastName,
        phone: data.Phone,
        productInterestc: productName,
        mktoPersonNotes: data.OtherInterest,
        state: String(data.CompanyState || ''),
        postalCode: data.PostalCode,
        optIn: data.HasUserConsent ? 'yes' : '',
        variant: 'Platts'
    };
    return body;
};


function RequestTrialPlatts(props: RequestATrialFormProps) {
    const { productName = '', productVariant, titleText, ratVariant } = props;
    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        const requestBody = getPlattsSubmissionBody(productName, data);
        submitToMarketo(requestBody, cb, error);

    };
    return (
        <RequestTrialForm onSubmitForm={onSubmit} formTextFields={getPlattsformFields()} productVariant={productVariant} titleText={titleText} ratVariant={ratVariant} />
    );
}

export default React.memo(RequestTrialPlatts);
